import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Label, Input, FormFeedback } from 'reactstrap';

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            tipo: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id,
            tipo: data.tipo_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.clientes.responsables.edit}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Contacto"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                buttonTitle={"Ver Contacto"}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                onGotData={(data) => this.setSelects(data)}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Nombre</Label>
                                    <Input disabled={true} type="text" name="nombre"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Apellido</Label>
                                    <Input disabled={true} type="text" name="apellido"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa</Label>
                                    <ParadigmaAsyncSeeker disabled={true} fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos de contacto</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Tipo</Label>
                                    <ParadigmaAsyncSeeker disabled={true} value={this.state.tipo} fieldName={"tipo_id"} multiselect={true} url={api.clientes.tiporesponsables.select} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Teléfono</Label>
                                    <Input disabled={true} type="text" name="telefono"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Email</Label>
                                    <Input disabled={true} type="text" name="email"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input disabled={true} type="textarea" name="observaciones" rows="5"/>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Detail.js